/**
 * Web 导航系统的 React Hooks
 * 
 * 提供便捷的 hooks 来简化 Web 导航的使用
 */

import { useNavigation } from '@react-navigation/native';
import { Platform } from 'react-native';
import globalEventBus from './EventBus';
import { WebNavigationHelper } from './WebNavigationHelper';

/**
 * 使用 Web 智能导航的 Hook
 * 
 * @example
 * const navigate = useWebNavigation();
 * navigate('ContactInfo', { current: user, type: 'FRIEND' });
 */
export function useWebNavigation() {
    const navigation = useNavigation();
    
    return (screenName: string, params?: any) => {
        WebNavigationHelper.navigate(navigation as any, screenName, params);
    };
}

/**
 * 使用 Web 智能返回的 Hook
 * 
 * @example
 * const goBack = useWebGoBack();
 * goBack();
 */
export function useWebGoBack() {
    const navigation = useNavigation();
    
    return () => {
        WebNavigationHelper.goBack(navigation as any);
    };
}

/**
 * 判断当前是否在 Web 三栏模式
 */
export function useIsWebThreeColumn(): boolean {
    return Platform.OS === 'web';
}

/**
 * Hook：检查页面是否应该隐藏返回按钮
 * 
 * @example
 * const shouldHideBack = useWebNavBarConfig('ContactInfo');
 * <NavBar showBack={!shouldHideBack} />
 */
export function useWebNavBarConfig(screenName: string) {
    const shouldHideBack = WebNavigationHelper.shouldHideBackButton(screenName);
    
    return {
        shouldHideBack,
        showBack: !shouldHideBack
    };
}
